function initCtaSwipers() {
  const els = document.querySelectorAll('[data-cta-swiper]');
  if (els.length === 0) {
    return;
  }
  els.forEach(el => {
    const transitionEffect = el.getAttribute('data-transition');
    const autoplay = el.getAttribute('data-autoplay');
    const speed = el.getAttribute('data-speed');
    let transitionEffectConfig;
    let autoplayConfig;
    let crossFadeEnabled;
    if (transitionEffect === 'fade') {
      transitionEffectConfig = 'fade';
      crossFadeEnabled = true;
    } else {
      transitionEffectConfig = 'slide';
      crossFadeEnabled = false;
    }
    if (autoplay === 'none') {
      autoplayConfig = false;
   } else {
      autoplayConfig = {
        delay: parseInt(speed * 1000)
      };
    }
    const swiper = new Swiper(el, {
      autoplay: autoplayConfig,
      speed: 500,
      effect: transitionEffectConfig,
      fadeEffect: {
        crossFade: crossFadeEnabled
      },
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      }
    });
  });
}

function initTestimonialSwipers() {
  const els = document.querySelectorAll('[data-testimonial-swiper]');
  if (els.length === 0) {
    return;
  }
  els.forEach(el => {
    const swiper = new Swiper(el, {
      slidesPerView: 1.5,
      slidesPerGroup: 1,
      loop: true,
      breakpoints: {
        768: {
          slidesPerView: 'auto',
          slidesPerGroup: 1,
        }
      }
    });
  });
}

function initIngredientSwipers() {
  const els = document.querySelectorAll('[data-ingredient-swiper]');
  if (els.length === 0) {
    return;
  }
  els.forEach(el => {
    const swiper = new Swiper(el, {
      slidesPerView: 1.5,
      slidesPerGroup: 1,
      loop: true,
      breakpoints: {
        768: {
          slidesPerView: 'auto',
          slidesPerGroup: 1,
        }
      }
    });
  });
}

window.addEventListener('DOMContentLoaded', function () {
  initCtaSwipers();
  initTestimonialSwipers();
  initIngredientSwipers();
});